// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.accordion-item {
    border-bottom: 1px solid #ccc;
  }*/
  
  .accordion-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background-color: #f5f5f5;
    cursor: pointer;
    border-radius: 10px;
  }
  
  .accordion-header:hover {
    background-color: #e0e0e0;
  }
  
  .accordion-content {   
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 15px;
    padding-right: 15px;
    overflow: hidden;
    transition: max-height 0.3s ease;
  }
  
  .accordion-icon {
    width: 10px;
    height: 10px;
    border-left: 2px solid black;
    border-bottom: 2px solid black;
    transform: rotate(-45deg);
    transition: transform 0.3s ease;
  }
  
  .accordion-item.active .accordion-icon {
    transform: rotate(45deg);
  }
  `, "",{"version":3,"sources":["webpack://./src/app/accordion/accordion.component.css"],"names":[],"mappings":"AAAA;;IAEI;;EAEF;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,8BAA8B;IAC9B,yBAAyB;IACzB,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B","sourcesContent":["/*.accordion-item {\r\n    border-bottom: 1px solid #ccc;\r\n  }*/\r\n  \r\n  .accordion-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 10px;\r\n    background-color: #f5f5f5;\r\n    cursor: pointer;\r\n    border-radius: 10px;\r\n  }\r\n  \r\n  .accordion-header:hover {\r\n    background-color: #e0e0e0;\r\n  }\r\n  \r\n  .accordion-content {   \r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n    overflow: hidden;\r\n    transition: max-height 0.3s ease;\r\n  }\r\n  \r\n  .accordion-icon {\r\n    width: 10px;\r\n    height: 10px;\r\n    border-left: 2px solid black;\r\n    border-bottom: 2px solid black;\r\n    transform: rotate(-45deg);\r\n    transition: transform 0.3s ease;\r\n  }\r\n  \r\n  .accordion-item.active .accordion-icon {\r\n    transform: rotate(45deg);\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
